import { Mail, Phone } from "lucide-react";
import styles from "./ContactUs.module.scss";

const ContactUs: React.FC = () => {
  return (
    <div className={styles.root}>
      <h2 className={styles.title}>Contact Us</h2>
      <p>
        Web Finance Direct is here to connect dealers and lenders with the right
        opportunities. Reach out today.
      </p>

      <div className={styles.contact}>
        <div className={styles.contactItem}>
          <Mail color="#b7cdff" size={50} />
          <h2>support@webfinancedirect.com</h2>
        </div>
        <div className={styles.contactItem}>
          <Phone color="#b7cdff" size={50} />
          <h2>833-933-2120</h2>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
